export class PagingInputDTO {
    pageNumber: number;
    pageCount: number;
    permitType: number;

    constructor() {
        this.pageNumber = 1;
        this.pageCount = 12;
        this.permitType = 0;
    }
}